import React from 'react'

import Grid from 'components/Grid'

import FeatureDetail from '../FeatureDetail'

import classes from './FeaturesList.module.scss'

/** @type {import("./types").default} */
const FeaturesList = ({ defaultList }) => (
  <Grid className={classes.root} container spacing={2}>
    {defaultList.map(feature => (
      <Grid item xs={12} key={feature.slug}>
        <FeatureDetail feature={feature} />
      </Grid>
    ))}
  </Grid>
)

export default FeaturesList
